import type { Tracker } from './tracker';

/** @internal 工厂失败时返回无定时器、无网络行为且可链式调用的实例。 */
function noopTracker(): Tracker {
  const tracker = {
    use: () => tracker,
    setContext: () => tracker,
    registerContextProvider: () => tracker,
    track: () => undefined,
    flush: async () => undefined,
    destroy: () => undefined,
  };
  return tracker as unknown as Tracker;
}

/** @internal retain 用于清理工厂中途失败前已创建的实例。 */
export function safeTrackerFactory(build: (retain: (tracker: Tracker) => Tracker) => Tracker): Tracker {
  let partial: Tracker | undefined;
  try {
    return build((tracker) => { partial = tracker; return tracker; });
  } catch {
    try { partial?.destroy(); } catch { /* 初始化失败仍须返回安全实例。 */ }
    return noopTracker();
  }
}
